import { Box, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { KeyboardScrollBox } from "../../common/KeyboardScrollBox";
import { useTranslation } from "react-i18next";
import { FiEye } from "react-icons/fi";
import { ViewingOrganizationDto } from "../../autogen/bff-api";
import { formatDateTime } from "../../common/components/communication/communicationUtils";
import { SectionCard } from "../sourcing-events/portal/view-single/SectionCard";

interface Props {
  viewings: ViewingOrganizationDto[];
}

export const ViewingsSection = ({ viewings }: Props) => {
  const { t } = useTranslation();

  return (
    <SectionCard icon={FiEye} title={t("Views")} count={viewings.length}>
      <Box border="1px solid" borderColor="smBorder" rounded="md" overflow="hidden">
        <KeyboardScrollBox as={TableContainer}>
          <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th>{t("Organization name")}</Th>
              <Th>{t("Last viewed")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {viewings.map((viewing) => (
              <Tr key={viewing.organizationId}>
                <Td>
                  <Text fontSize="sm">{viewing.organizationName}</Text>
                </Td>
                <Td>
                  <Text fontSize="sm" color="smMuted">
                    {formatDateTime(viewing.lastViewedAt)}
                  </Text>
                </Td>
              </Tr>
            ))}
            {viewings.length === 0 && (
              <Tr>
                <Td colSpan={2} textAlign="center" color="smMuted">
                  {t("No organizations have viewed this event yet.")}
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
        </KeyboardScrollBox>
      </Box>
    </SectionCard>
  );
};
